import React from 'react';
import {Navigate} from 'react-router-dom';
import {getCurrentUserRole, isTokenValid} from "../../utils/auth";

const isAuthenticated = () => {
    return isTokenValid();
};

const PrivateRoute = ({ element, allowedRoles = ["ADMIN"] }) => {
    if (!isAuthenticated()) {
        return <Navigate to="/login" state={{from: window.location.pathname}} />;
    }

    return allowedRoles.includes(getCurrentUserRole())
        ? element
        : <Navigate to="/login" replace />;
};

export default PrivateRoute;
